import styled from "styled-components"
import lockScanMealBg from "assets/images/locked-scan-meal-bg.png"
import lockScanMealRight from "assets/images/locked-scan-meal-right.png"
import UnlockIcon from "./Icons/UnlockIcon"

export const LockedAIScanBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: var(--spacing_m, 12px) var(--spacing_xs, 6px) var(--spacing_m, 12px)
    var(--spacing_m, 12px);
  border-radius: var(--spacing_s, 8px);
  background-size: contain;
  color: #1c1f21;
  cursor: pointer;
  background: #fbfbfb;
  position: relative;
  overflow: hidden;
`

export const LockedTitle = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
`

export const LockDescription = styled.p`
  font-weight: 500;
  line-height: 15px;
  color: var(--Schemes-Surface-On-surface-On-Surface-Variant-2, #69757d);
  font-size: 12px;
`

export const LockedAIScanBoxInfo = styled.div`
  martin-top: 4px;
  z-index: 2;
`

export const UnlockButton = styled.div`
  justify-self: flex-start;
  margin-top: 8px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px 12px;
  gap: var(--spacing_xxs, 4px);

  border-radius: var(--card_corner, 8px);
  background: var(--fatColor, #f7c945);

  span {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.14px;
    line-height: 14px;
    position: relative;
    top: 1px;
  }
`

const LockScanImageBox = styled.div`
  display: flex;
  padding: 0px 3px 0px 3px;
  justify-content: center;
  align-items: center;
  z-index: 2;
`

const LockScanImage = styled.img`
  width: 83px;
  height: 76px;
  object-fit: cover;
`

const AIScanBox = ({
  isLocked,
  onClick,
}: {
  isLocked: boolean
  onClick: () => void
}) => {
  return isLocked ? (
    <LockedAIScanBoxWrapper onClick={onClick}>
      <img
        src={lockScanMealBg}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 1,
          left: 0,
        }}
      />
      <LockedAIScanBoxInfo>
        <LockedTitle>Want to log your food faster? </LockedTitle>
        <LockDescription>Let AI do the work for you!</LockDescription>

        <UnlockButton>
          <UnlockIcon /> <span>Unlock Premium</span>
        </UnlockButton>
      </LockedAIScanBoxInfo>

      <LockScanImageBox>
        <LockScanImage src={lockScanMealRight} alt="lock-scan-meal" />
      </LockScanImageBox>
    </LockedAIScanBoxWrapper>
  ) : undefined
}

export default AIScanBox
